type TActiveIconProps = {
	active: boolean
}

type TZoomIconProps = TActiveIconProps & {
	selected: boolean
}

export const SelectToolIcon = ({ active }: TActiveIconProps) => {
	const color = active ? "currentColor" : "currentColor"
	return (
		<svg width="16" height="16" viewBox="0 0 14 14" fill="none" aria-hidden="true">
			<path
				d="M1.9349 0.601562C1.58127 0.601563 1.24214 0.742038 0.992087 0.992087C0.742038 1.24214 0.601563 1.58127 0.601562 1.9349M11.2682 0.601562C11.6219 0.601563 11.961 0.742038 12.211 0.992087C12.4611 1.24214 12.6016 1.58127 12.6016 1.9349M1.9349 12.6016C1.58127 12.6016 1.24214 12.4611 0.992087 12.211C0.742038 11.961 0.601563 11.6219 0.601562 11.2682M4.60156 0.601562H5.26823M4.60156 12.6016H5.9349M7.9349 0.601562H8.60156M0.601562 4.60156V5.26823M12.6016 4.60156V5.9349M0.601562 7.9349V8.60156M6.60156 6.60156L9.26823 13.2682L10.4016 10.4016L13.2682 9.26823L6.60156 6.60156Z"
				stroke={color}
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export const PanToolIcon = ({ active }: TActiveIconProps) => {
	const color = active ? "currentColor" : "currentColor"
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
			<path
				d="M12 7.33333V4C12 3.64638 11.8595 3.30724 11.6095 3.05719C11.3594 2.80714 11.0203 2.66667 10.6667 2.66667C10.313 2.66667 9.97391 2.80714 9.72386 3.05719C9.47381 3.30724 9.33333 3.64638 9.33333 4M9.33333 6.66667V2.66667C9.33333 2.31304 9.19286 1.97391 8.94281 1.72386C8.69276 1.47381 8.35362 1.33333 8 1.33333C7.64638 1.33333 7.30724 1.47381 7.05719 1.72386C6.80714 1.97391 6.66667 2.31304 6.66667 2.66667V4M6.66667 4V7M6.66667 4C6.66667 3.64638 6.52619 3.30724 6.27614 3.05719C6.02609 2.80714 5.68695 2.66667 5.33333 2.66667C4.97971 2.66667 4.64057 2.80714 4.39052 3.05719C4.14047 3.30724 4 3.64638 4 4V9.33333M12.0001 5.33333C12.0001 4.97971 12.1405 4.64057 12.3906 4.39052C12.6406 4.14048 12.9798 4 13.3334 4C13.687 4 14.0262 4.14048 14.2762 4.39052C14.5263 4.64057 14.6667 4.97971 14.6667 5.33333V9.33333C14.6667 10.7478 14.1048 12.1044 13.1046 13.1046C12.1044 14.1048 10.7479 14.6667 9.3334 14.6667H8.00007C6.1334 14.6667 5.00007 14.0933 4.00673 13.1067L1.60673 10.7067C1.37736 10.4526 1.25446 10.1201 1.26348 9.77796C1.27251 9.43581 1.41277 9.11023 1.65521 8.86864C1.89766 8.62705 2.22374 8.48794 2.56592 8.48013C2.9081 8.47232 3.24018 8.59639 3.4934 8.82667L4.66673 10"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export const ZoomInIcon = ({ selected, active }: TZoomIconProps) => {
	const color = selected || active ? "currentColor" : "currentColor"
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
			<circle cx="6.5" cy="6.5" r="4" stroke={color} strokeWidth="1.5" />
			<line x1="9.5" y1="9.5" x2="13" y2="13" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
			<line x1="4.8" y1="6.5" x2="8.2" y2="6.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
			<line x1="6.5" y1="4.8" x2="6.5" y2="8.2" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
		</svg>
	)
}

export const ZoomOutIcon = ({ selected, active }: TZoomIconProps) => {
	const color = selected || active ? "currentColor" : "currentColor"
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
			<circle cx="6.5" cy="6.5" r="4" stroke={color} strokeWidth="1.5" />
			<line x1="9.5" y1="9.5" x2="13" y2="13" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
			<line x1="4.8" y1="6.5" x2="8.2" y2="6.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
		</svg>
	)
}

export const FitToWidthIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<path
			d="M13 13L9 9M9.8 13H13V9.8M4.2 13H1V9.8M1 13L5 9M9.8 1H13V4.2M13 1L9 5M4.2 1H1V4.2M1 1L5 5"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

// REQ-395/396: Note tool toolbar button. Figma's icon here is the shared "Icon / Type" component
// (node 13042:129062, exported asset, fetched via `get_design_context` on the header instance at
// frame `18916:553647` / node `18916:553663`) — no existing icon in `components/ui/` matches it
// (checked first, per AGENTS.md). Exact exported path below, not hand-drawn.
export const NoteToolIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<path
			d="M2.66667 4.66667V2.66667H13.3333V4.66667M6 13.3333H10M8 2.66667V13.3333"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export const FitToPageIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<path
			d="M13 5V1H9M13 1L8.333 5.667M1 9V13H5M1 13L5.667 8.333"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

// REQ-400: the "Shapes" toolbar entry point — a small square + the chevron that opens the shape-type
// dropdown (Figma "Shapes / Opened", node 19019:671577 / :671809).
export const ShapesToolIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<rect x="2.5" y="2.5" width="11" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
	</svg>
)

/**
 * REQ-400 #1324 — the freehand highlight tool's toolbar glyph: a marker/highlighter nib drawn on a
 * diagonal, matching the design (node 18916:553340). Stroke-only and sized like every other icon in
 * this file, so it inherits `currentColor` for the active/inactive button states.
 */
export const HighlightToolIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<path
			d="M10.9 2.4 13.6 5.1 7.2 11.5l-3.3.6.6-3.3 6.4-6.4Z"
			stroke="currentColor"
			strokeWidth="1.3"
			strokeLinejoin="round"
		/>
		<line x1="2.5" y1="14.2" x2="13.5" y2="14.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
	</svg>
)

export const RectangleShapeIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<rect x="1.5" y="3.5" width="13" height="9" rx="1" stroke="currentColor" strokeWidth="1.3" />
	</svg>
)

export const EllipseShapeIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<ellipse cx="8" cy="8" rx="6.5" ry="4.5" stroke="currentColor" strokeWidth="1.3" />
	</svg>
)

// REQ-400 §1381 review: the Opacity slider's trigger icon — a half-filled circle (gauge), matching
// Figma's "Icon / Opacity".
export const OpacityIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.3" />
		<path d="M8 2a6 6 0 0 1 0 12z" fill="currentColor" />
	</svg>
)

// REQ-400 §1381 review: the Stroke width slider's trigger icon — three stacked bars of increasing
// weight, matching Figma's "Icon / Stroke".
export const StrokeWidthIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<line x1="2" y1="4.5" x2="14" y2="4.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
		<line x1="2" y1="8" x2="14" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
		<line x1="2" y1="11.5" x2="14" y2="11.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
	</svg>
)

export const CheckmarkIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
		<path d="m2.5 6.2 2.2 2.2 4.8-4.9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)
